<template>
  <div class="head-line">
    <slot/>
  </div>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>

.head-line {
  background: rgba($color: $mainGreen, $alpha: 0.2);
  color: $mainGreen;
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;

  display: flex;
  flex-direction: row;
  align-items: center;

  margin: 0 -30px;
  padding: 7px 30px;
}

</style>